import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import serviceHTTPHelper from '../service-http-helper';
var CC_ENDPOINT = 'credit_cards';
/**
 *
 * @param {Object} ServiceSDK - A base ServiceSDK to use
 * @param {Object} config
 * @param {string} config.offerBaseUrl - The base URL for the offer API
 * @param {string} config.version - The API version number. Defaults to 0 for CC, 1 for others
 * @param {string} config.Referer - The Referer header to use
 * @returns {SDK} - The OfferSDK you can use to easily query against the Offer API
 * @constructor
 */

export default function OfferSDK(ServiceSDK, config) {
  if (!config || _typeof(config) !== 'object') {
    throw new Error('A config object is required to initialize OfferSDK');
  } else if (!config.offerBaseUrl) {
    throw new Error('Attempted to initialize offer SDK but no base URL found. Please pass through' + ' a config object with the `offerBaseUrl` property');
  }

  function offerRoute(endpoint) {
    /**
     * CC clients using /finproservices/ expect data in a certain format, which is the same as the v0
     * results in /marketplace/. So default them to v0 unless they explicitly want v1.
     */
    var version = 1;

    if (config.version) {
      version = config.version;
    } else if (endpoint === CC_ENDPOINT) {
      version = 0;
    }

    return ServiceSDK.nwApiRoute(config.offerBaseUrl, 'offers', version, "".concat(endpoint, "/search"));
  } // the default response handler returns response.data


  var responseHandlerOptions = {
    dataParser: function dataParser(response) {
      return response;
    }
  };
  var service = serviceHTTPHelper(ServiceSDK, offerRoute, responseHandlerOptions);

  var getReferer = function getReferer(serverRequest) {
    return get(config, 'Referer') || serverRequest.get('Referer') || serverRequest.get('x-originating-url') || '';
  };

  function getOffers(endpoint, payload, serverRequest) {
    var payloadToUse = get(payload, 'getJSON') ? payload.getJSON() : payload;
    var options = serverRequest ? {
      headers: {
        Referer: getReferer(serverRequest)
      }
    } : {};
    return service.post(endpoint, payloadToUse, serverRequest, options);
  }

  function getBankingProducts(payload, serverRequest) {
    return getOffers('banking', payload, serverRequest);
  }

  function getCreditCards(payload, serverRequest) {
    return getOffers('credit_cards', payload, serverRequest);
  }

  function getInvestingProducts(payload, serverRequest) {
    return getOffers('investing', payload, serverRequest);
  }

  return {
    getBankingProducts: getBankingProducts,
    getCreditCards: getCreditCards,
    getInvestingProducts: getInvestingProducts,
    getOffers: getOffers
  };
}